export const EMAIL = "hello@titoipinmoye.com";

export const NAV_LINKS = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/about", label: "About", testid: "nav-about" },
  { to: "/our-work", label: "Our Work", testid: "nav-our-work" },
  { to: "/partnerships", label: "Partnerships", testid: "nav-partnerships" },
  { to: "/research-innovation", label: "Research & Innovation", testid: "nav-research" },
  { to: "/founders", label: "Founders", testid: "nav-founders" },
  { to: "/insights", label: "Insights", testid: "nav-insights" },
  { to: "/masterclass", label: "Masterclass", testid: "nav-masterclass" },
  { to: "/book", label: "Book", testid: "nav-book" },
];

export const CAPABILITIES = [
  { title: "Clinical Nutrition", desc: "Evidence-based nutrition programmes grounded in real healthcare needs." },
  { title: "Digital Health", desc: "Technology-enabled approaches to nutrition, chronic disease management and patient support." },
  { title: "Product Development", desc: "From problem discovery and clinical workflows to product strategy, design and implementation." },
  { title: "Healthcare Innovation", desc: "Helping organisations rethink how nutrition and healthcare can be delivered at scale." },
  { title: "Education & Capacity Building", desc: "Building nutrition knowledge and practical skills for professionals, organisations and communities." },
];

export const STATS = [
  { value: 10, suffix: "+", label: "Nutrition & healthcare technology products supported" },
  { value: 10000, suffix: "+", label: "People reached through healthcare and nutrition programmes" },
  { value: 10000, suffix: "+", label: "Healthy meals delivered through ventures within our ecosystem" },
  { value: 50, suffix: "+", label: "Cancer patients supported through oncology nutrition work" },
];

export const EVOLUTION = [
  { title: "Clinical Nutrition", desc: "Evidence-based clinical nutrition and patient care." },
  { title: "Nutrition Education", desc: "Making nutrition science practical and accessible." },
  { title: "Nutrition Technology", desc: "Translating clinical expertise into nutrition databases, programmes and digital tools." },
  { title: "Digital Health", desc: "Building products that extend nutrition and chronic disease support beyond traditional clinical settings." },
  { title: "AI & Intelligent Healthcare", desc: "Exploring artificial intelligence, clinical decision support and nutrition intelligence." },
  { title: "Healthcare Transformation", desc: "Supporting organisations to improve products, processes and systems." },
];

export const HERO_FLOW = ["Nutrition", "Clinical Care", "Product", "Technology", "Healthcare", "Impact"];

export const MARQUEE_ITEMS = [
  "Clinical Nutrition",
  "Digital Health",
  "Product Development",
  "Healthcare Innovation",
  "Education",
  "Research",
  "Strategic Partnerships",
];

export const CATEGORIES = [
  { key: "all", label: "All" },
  { key: "built", label: "Built & Venture Building" },
  { key: "partners", label: "Built With Partners" },
  { key: "education", label: "Education & Capacity Building" },
];

export const PROJECTS = [
  {
    slug: "platemind",
    name: "PlateMind",
    tagline: "AI-powered clinical nutrition and diabetes decision support",
    desc: "An AI-enabled nutrition platform designed to help people living with diabetes better understand food, glucose and everyday health decisions.",
    category: "built",
    flagship: true,
    contribution: ["Clinical Nutrition", "Product Strategy", "AI Product Development", "Nutrition Intelligence"],
    url: "https://platemind.app",
    initial: "P",
  },
  {
    slug: "onconourish",
    name: "OncoNourish",
    tagline: "Technology-enabled oncology nutrition",
    desc: "A patient-centred nutrition platform designed to support people throughout cancer treatment.",
    category: "built",
    flagship: true,
    contribution: ["Oncology Nutrition", "Product Strategy", "Clinical Model", "Patient Experience", "Innovation"],
    url: "https://onconourish.com",
    initial: "O",
  },
  {
    slug: "lana-clinical",
    name: "Lana Clinical",
    tagline: "AI-powered healthcare innovation",
    desc: "An AI-enabled healthcare product developed through the Build the Future of Healthcare Hackathon in London.",
    category: "built",
    flagship: true,
    contribution: ["Product Development", "Clinical Expertise", "AI Innovation", "Human-Centred Design"],
    url: "https://lanaclinical.com/",
    initial: "L",
  },
  {
    slug: "sito-health",
    name: "Sito Health",
    tagline: "Specialist metabolic health care",
    desc: "A metabolic health clinic combining clinical nutrition expertise with digital care, in person and online.",
    category: "built",
    flagship: true,
    contribution: ["Venture Building", "Product Strategy", "Clinical Nutrition", "Digital Care Design"],
    url: "https://sitohealth.com/",
    initial: "S",
  },
  {
    slug: "balance-clinic",
    name: "The Balance Clinic",
    tagline: "Digital-first weight management and lifestyle medicine",
    desc: "A women-focused weight-management model integrating nutrition, behaviour change and clinical care.",
    category: "built",
    flagship: false,
    contribution: ["Product Strategy", "Clinical Programme Design", "Behaviour Change", "Service Design"],
    url: "https://www.cookedindoors.com/balance",
    initial: "B",
  },
  {
    slug: "akaani",
    name: "Akaani",
    tagline: "Personalised nutrition technology",
    desc: "Personalised nutrition technology built with nutrition intelligence at its core.",
    category: "partners",
    flagship: false,
    contribution: ["Nutrition Intelligence", "Recipe Database", "Nutrition Strategy", "Product Development"],
    url: "https://www.useakaani.com/",
    initial: "A",
  },
  {
    slug: "fitprep",
    name: "FitPrep",
    tagline: "Fitness and nutrition technology",
    desc: "Fitness and nutrition technology connecting training with structured nutrition.",
    category: "partners",
    flagship: false,
    contribution: ["Nutrition Architecture", "Nutrition Mapping", "Product Strategy", "Meal Planning"],
    url: "https://thefitprep.com",
    initial: "F",
  },
  {
    slug: "pocketfood",
    name: "PocketFood",
    tagline: "Nutrition-led food technology",
    desc: "Nutrition-led food technology with therapeutic nutrition programmes.",
    category: "partners",
    flagship: false,
    contribution: ["Therapeutic Nutrition", "Diabetes Programmes", "Nutrition Product Development"],
    url: "https://www.pocketfood.io/",
    initial: "P",
  },
  {
    slug: "qilo",
    name: "Qilo",
    tagline: "Digital weight management and metabolic health",
    desc: "Digital weight management and metabolic health programmes.",
    category: "partners",
    flagship: false,
    contribution: ["Nutrition Programme Design", "Metabolic Health", "Nutrition Product Development"],
    url: null,
    initial: "Q",
  },
  {
    slug: "chronicare",
    name: "ChroniCare",
    tagline: "Diabetes Management Centre",
    desc: "TNN Africa partnered with Chronicler, an ISN Medical company, to run the nutrition clinic within ChroniCare, a Lagos-based centre for personalised chronic disease and diabetes care.",
    category: "partners",
    flagship: false,
    contribution: ["Nutrition Clinic Operations", "Clinical Nutrition", "Nutrition Programme Design", "Patient Support"],
    url: "https://diabetes.chronicare.org",
    initial: "C",
  },
  {
    slug: "healthy-cooking-masterclass",
    name: "Healthy Cooking Masterclass",
    tagline: "Nutrition education through food",
    desc: "A culinary nutrition education initiative translating nutrition science into practical cooking skills and healthier food choices.",
    category: "education",
    flagship: false,
    contribution: ["Culinary Nutrition", "Curriculum Development", "Nutrition Education", "Health Communication"],
    url: "https://healthycookingmasterclass.com/",
    initial: "H",
  },
];

export const CASE_STUDIES = {
  platemind: {
    slug: "platemind",
    name: "PlateMind",
    tagline: "AI for everyday diabetes decisions",
    url: "https://platemind.app",
    initial: "P",
    challenge: {
      paragraphs: [
        "People living with diabetes make food decisions every day, but conventional diabetes tools often separate food information from glucose information.",
      ],
      bullets: ["Can I eat this meal?", "Why did my glucose change?", "What should I change next time?"],
      closing:
        "The challenge is therefore not simply tracking glucose, but helping people understand the relationship between what they eat and what happens to their glucose.",
    },
    solution: {
      paragraphs: [
        "PlateMind is an AI-powered nutrition platform that helps people understand how food affects blood glucose and make better everyday decisions.",
      ],
      bullets: [
        "Meal analysis",
        "Food and nutrition information",
        "Carbohydrate analysis",
        "Glycaemic impact information",
        "Glucose tracking",
        "Personalised insights",
        "AI guidance",
        "A virtual dietitian, Lana",
      ],
      closing:
        "PlateMind is designed around the foods people actually eat, including culturally diverse meals. The platform connects food choices and glucose patterns rather than simply tracking numbers.",
    },
    role: ["Clinical Nutrition", "Product Strategy", "Nutrition Intelligence", "AI Product Development", "Product Design"],
    roleNote:
      "The project translates clinical nutrition knowledge into product logic, nutrition data structures, meal analysis and user-facing decision support.",
    contribution: ["Clinical Nutrition", "Product Strategy", "Nutrition Intelligence", "AI Product Development", "User Experience", "Implementation"],
    innovation: {
      paragraphs: [
        "The key innovation is connecting food intelligence with glucose intelligence. Instead of treating nutrition as a static database or glucose as an isolated number, PlateMind creates a feedback loop:",
      ],
      flow: ["Food", "Nutrition Analysis", "Glucose", "Pattern", "Insight", "Better Decision"],
      closing:
        "The platform also incorporates culturally relevant food intelligence rather than designing only around generic Western food databases.",
    },
    evidence: [
      "Live product in market",
      "AI-powered meal analysis",
      "Glucose tracking",
      "Nutrition intelligence sourced from global food composition tables",
      "Culturally diverse food support",
      "Virtual dietitian experience",
      "Product designed by clinical dietitians",
    ],
  },
  onconourish: {
    slug: "onconourish",
    name: "OncoNourish",
    tagline: "Clinical nutrition support during cancer treatment",
    url: "https://onconourish.com",
    initial: "O",
    challenge: {
      paragraphs: ["Cancer treatment can make eating difficult. Patients may experience:"],
      bullets: [
        "Loss of appetite",
        "Changes in taste",
        "Early fullness",
        "Nausea",
        "Fatigue",
        "Unintentional weight loss",
        "Stress and uncertainty around food",
      ],
      closing:
        "The challenge is that generic nutrition advice does not always reflect what a person can realistically eat during treatment.",
    },
    solution: {
      paragraphs: [
        "OncoNourish is a patient-centred clinical nutrition support service designed around the realities of eating during cancer treatment. Rather than prescribing rigid meal plans, the model focuses on:",
      ],
      bullets: [
        "Finding foods patients can tolerate",
        "Adapting meals according to symptoms",
        "Supporting weight and strength",
        "Managing food-related side effects",
        "Providing practical day-to-day guidance",
        "Supporting caregivers",
      ],
      closing: "The OncoNourish model follows a three-step approach: Listen, create a plan, and adjust with the patient.",
    },
    role: ["Clinical Nutrition", "Oncology Nutrition", "Product Strategy", "Service Design", "Patient Experience", "Healthcare Innovation"],
    roleNote: "The project translates oncology nutrition expertise into a structured patient support model.",
    contribution: ["Oncology Nutrition", "Clinical Model", "Service Design", "Patient Experience", "Product Strategy", "Implementation"],
    innovation: {
      paragraphs: [
        "The central innovation is moving away from generic cancer nutrition advice toward symptom-responsive, patient-centred nutrition support. The product is designed around the question \u201cWhat can this person realistically eat today?\u201d rather than simply \u201cWhat should a cancer patient eat?\u201d",
      ],
      flow: ["Listen", "Create a Plan", "Adjust Together"],
      closing: "This creates a more human and adaptable model of nutrition support.",
    },
    evidence: [
      "A live patient-facing service",
      "Structured clinical nutrition support",
      "Symptom-responsive nutrition model",
      "Dedicated caregiver support",
      "Evidence-informed clinical approach",
      "Integration with, rather than replacement of, oncology care",
      "Service led by Tito Ipinmoye, designed to complement medical care",
    ],
  },
  "lana-clinical": {
    slug: "lana-clinical",
    name: "Lana Clinical",
    tagline: "AI-powered healthcare innovation",
    url: "https://lanaclinical.com/",
    initial: "L",
    challenge: {
      paragraphs: [
        "Healthcare professionals and patients increasingly interact with complex information, but healthcare technology needs to be designed around real clinical workflows and human needs, rather than simply adding AI to existing processes.",
        "The Build the Future of Healthcare Hackathon provided an environment to rapidly explore and develop a healthcare technology solution.",
      ],
      bullets: [],
      closing: null,
    },
    solution: {
      paragraphs: [
        "Lana Clinical is an AI-enabled healthcare product developed through the Build the Future of Healthcare Hackathon in London. The project brought together:",
      ],
      bullets: ["Clinical expertise", "Product thinking", "Technology", "AI", "Human-centred design"],
      closing: null,
    },
    role: ["Clinical Expertise", "Product Development", "Product Strategy", "AI Innovation", "Human-Centred Design"],
    roleNote:
      "The project demonstrates TNN Africa's ability to move from a healthcare problem to a working technology concept within an accelerated innovation environment.",
    contribution: ["Clinical Expertise", "Product Strategy", "Product Development", "AI Innovation", "Human-Centred Design", "Prototyping"],
    innovation: {
      paragraphs: [
        "The significance of Lana Clinical is not simply that AI was used. The innovation lies in applying AI within a healthcare product through a clinical and user-centred product-development process. It demonstrates TNN Africa's ability to:",
      ],
      bullets: [
        "Identify healthcare problems",
        "Translate clinical requirements into product requirements",
        "Work within a technology development environment",
        "Develop an AI-enabled product concept",
        "Prototype and test a healthcare solution",
      ],
      closing: null,
    },
    evidence: [
      "Lana Clinical product in development",
      "Participation in the Build the Future of Healthcare Hackathon, London",
      "Product demonstrations and development documentation",
      "Public posts about the project",
      "Live product URL",
    ],
  },
  "sito-health": {
    slug: "sito-health",
    name: "Sito Health",
    tagline: "Specialist metabolic health care, in person and online",
    url: "https://sitohealth.com/",
    initial: "S",
    challenge: {
      paragraphs: [
        "People living with chronic conditions often need ongoing nutrition support between clinical appointments, but access to personalised, specialist nutrition care can be limited. This creates a gap between clinical consultation and everyday life.",
        "Sito Health exists to close that gap, pairing clinical expertise with care people can actually reach.",
      ],
      bullets: [],
      closing: null,
    },
    solution: {
      paragraphs: [
        "Sito Health is a metabolic health clinic that combines clinical nutrition expertise with technology-enabled care. The clinic supports people managing diabetes, prediabetes, PCOS and other metabolic conditions through:",
      ],
      bullets: [
        "Specialist nutrition consultations",
        "Evidence-based care programmes",
        "In-person consultations in Lekki, Lagos",
        "Virtual consultations",
        "Digital tools that keep support going between visits",
      ],
      closing:
        "Sito grew out of TNN Africa's earlier work in AI-enabled nutrition (the Hutano Africa and Sito digital health platform, 2021 to 2024) and now operates as Sito Metabolic Health Clinic.",
    },
    role: ["Venture Building", "Clinical Nutrition", "Product Strategy", "AI-enabled Nutrition", "Digital Health", "Product Development"],
    roleNote:
      "Tito Ipinmoye co-founded Sito Health, and the clinic grew directly out of TNN Africa's work in nutrition and digital health.",
    contribution: ["Venture Building", "Clinical Nutrition", "Product Strategy", "AI-enabled Nutrition", "Digital Health", "Implementation"],
    innovation: {
      paragraphs: [
        "Sito's significance is the move from episodic nutrition advice to continuous, specialist care that people can actually access: in person, online and between appointments. The model combines:",
      ],
      flow: ["Clinical Nutrition Logic", "Health Data", "Digital Engagement", "Personalised Guidance"],
      closing:
        "The earlier AI-enabled platform phase became part of the intellectual foundation for TNN Africa's ongoing work in AI-enabled nutrition.",
    },
    evidence: [
      "Live clinic website with conditions, FAQs and consultation booking",
      "In-person consultations in Lekki, Lagos, alongside virtual consultations",
      "Documented TNN Africa relationship and product development history",
      "A 2026 accepted peer-reviewed workshop contribution by Tito Ipinmoye, \u201cDesigning for Engagement in AI-Enabled Nutrition Support: A Practitioner Use Case from Sito Health\u201d, documenting the platform phase launched in 2021",
      "Practitioner and research insight that continues to inform work on engagement in AI-enabled nutrition",
    ],
  },
};

export const PARTNER_TYPES = [
  { title: "Healthcare Organisations", desc: "Design nutrition programmes, clinical pathways and technology-enabled care." },
  { title: "Founders & Startups", desc: "Translate healthcare problems into products, validate ideas and build scalable ventures." },
  { title: "Technology Companies", desc: "Add clinical nutrition intelligence, evidence-based workflows and health expertise to digital products." },
  { title: "Research & Grant Partners", desc: "Design and implement locally relevant nutrition and health innovation programmes." },
];

export const COLLABORATORS = ["Akaani", "FitPrep", "PocketFood", "Qilo", "ChroniCare", "Cooked Indoors", "Healthy Cooking Masterclass"];

export const PROCESS_STEPS = [
  { num: "01", title: "Discover", desc: "Understand the problem." },
  { num: "02", title: "Design", desc: "Define the product, programme or intervention." },
  { num: "03", title: "Build", desc: "Develop the solution." },
  { num: "04", title: "Validate", desc: "Test with users and stakeholders." },
  { num: "05", title: "Implement", desc: "Move from concept to real-world delivery." },
];

export const RESEARCH_AREAS = [
  { title: "Nutrition Research", desc: "Evidence-based approaches to nutrition and health." },
  { title: "Digital Health Research", desc: "Understanding how technology can improve access, engagement and outcomes." },
  { title: "Clinical Innovation", desc: "Translating clinical knowledge into new care models." },
  { title: "Implementation", desc: "Moving evidence from research into practical healthcare delivery." },
];

export const GRANT_CAPABILITIES = [
  "Research",
  "Programme Design",
  "Digital Health",
  "Clinical Nutrition",
  "Implementation",
  "Monitoring & Evaluation",
  "Innovation",
];

export const INTEREST_OPTIONS = [
  "Digital Health",
  "Nutrition Innovation",
  "Research",
  "Grant Consortium",
  "Product Development",
  "Healthcare Transformation",
  "Strategic Partnership",
  "Other",
];

export const WHY_PARTNER = ["Clinical Knowledge", "Product Development", "Technology", "Local Context", "Entrepreneurship"];

export const PHILOSOPHY_FLOW = ["Understand", "Translate", "Build", "Test", "Scale"];
